import {
  IconButton,
  Box,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import { AccountAPIs, UserAPIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { ArrowForward, CancelOutlined } from "@mui/icons-material";
import { isValidPhoneNumber } from "../../../utils/validations";
import { removeNonNumeric } from "../../../utils/Utils";
import { AddHomeScreenModal } from "../../../components/auth/AddHomeScreenModal";
import {
  isAndroid,
  isIOS,
  isMobile,
  isMobileSafari,
} from "react-device-detect";
import { GuideToSafari } from "../../../components/auth/GuideToSafari";
import { DownloadFromMarket } from "../../../components/auth/DownloadFromMarket";

function ProfileSettingPersonalChangeMobilePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentMobile = location.state?.currentMobile || "09123456789";
  const { apiCall: sendOtp, loading } = useRequest(
    UserAPIs.sendChangeMobileOTP
  );
  const [mobile, setMobile] = useState("");
  const [open, setOpen] = useState(false);

  const handleSubmit = () => {
    sendOtp({
      data: { mobile: mobile },
      onSuccess: () => {
        navigate("/app/profile/setting/personal/change-mobile/otp", {
          replace: true,
          state: { currentMobile: currentMobile, newMobile: mobile },
        });
      },
    });
  };

  useState(() => {
    const toShow = localStorage.getItem("add-to-home-screen-visited");
    if (!Boolean(toShow) || toShow === "false") {
      setOpen(true);
    }
  }, []);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            تغییر تلفن همراه
          </Typography>
        }
      />

      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography typography="body2" color="grey.2">
            تلفن همراه جدید
          </Typography>
          <TextField
            name="mobile"
            inputProps={{
              inputMode: "numeric",
            }}
            error={mobile.length === 11 && !isValidPhoneNumber(mobile)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {mobile.length > 0 && (
                    <IconButton
                      onClick={() => {
                        setMobile("");
                      }}
                    >
                      <CancelOutlined sx={{ fontSize: 20 }} />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            value={mobile}
            onChange={(event) => {
              if (event.target.value === null) {
                setMobile("");
              } else {
                event.target.value.length < 12 &&
                  setMobile(removeNonNumeric(event.target.value));
              }
            }}
            sx={{ mt: "12px" }}
            fullWidth
            placeholder="شماره تلفن همراه خود را وارد نمایید"
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            mt: 1,
          }}
        >
          <Box>
            <LoadingButton
              onClick={handleSubmit}
              loading={loading}
              disabled={!isValidPhoneNumber(mobile)}
              variant="contained"
              color="primary"
              sx={{ height: 56, width: 48 }}
            >
              <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
      {!window.matchMedia("(display-mode: standalone)").matches && (
        <>
          {isMobileSafari && isMobile && (
            <AddHomeScreenModal open={open} setOpen={setOpen} />
          )}
          {isMobile && isAndroid && (
            <DownloadFromMarket open={open} setOpen={setOpen} />
          )}
          {isMobile && isIOS && !isMobileSafari && (
            <GuideToSafari open={open} setOpen={setOpen} />
          )}
        </>
      )}
    </>
  );
}

export default ProfileSettingPersonalChangeMobilePage;
